import axios from 'axios';

const api = axios.create({
    baseURL : process.env.REACT_APP_BASE_URL,
    headers: {
        'Authorization': process.env.REACT_APP_SECRET_KEY, 
        'Content-Type': 'multipart/form-data',
    },
});

export default api;